/* Keeps the header cart count honest.

   Dawn only refreshes #cart-icon-bubble when Dawn itself performs the add, via
   cart-notification.js / cart.js. Everything else leaves the header showing
   whatever the count was when the HTML was generated:

     - upsell and free-gift apps (Selleasy, BOGOS, Smart Discounts are all
       installed here) post to /cart/add.js themselves and never ask the
       theme to re-render,
     - a page restored from the back/forward cache is served verbatim, count
       and all,
     - a cached header can be served with a stale count to a returning visitor,
     - a cart changed in a second tab leaves this one behind.

   In each case the count is simply wrong until a hard reload — which is what
   "isn't always displaying the amount" looks like from the outside.

   Rather than compute the markup here, this asks Shopify to render the theme's
   own cart-icon-bubble section, so the bubble and the full/empty cart icon both
   come back exactly as header.liquid would have drawn them. */
(function () {
  var TARGET = 'cart-icon-bubble';
  var CART_WRITE = /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/;
  var pending = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  // Mirrors Dawn's own getSectionInnerHTML: the section response is wrapped in
  // its .shopify-section container, which must not be nested inside itself.
  function innerHTML(html) {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var section = doc.querySelector('.shopify-section');
    return section ? section.innerHTML : null;
  }

  function sync() {
    var el = document.getElementById(TARGET);
    if (!el) return;

    clearTimeout(pending);
    // Coalesce bursts — an app that adds three items fires three requests.
    pending = setTimeout(function () {
      fetch(root() + '?sections=' + TARGET, { credentials: 'same-origin' })
        .then(function (r) {
          return r.ok ? r.json() : Promise.reject(r.status);
        })
        .then(function (data) {
          var markup = innerHTML(data[TARGET]);
          var node = document.getElementById(TARGET);
          if (markup !== null && node && node.innerHTML !== markup) {
            node.innerHTML = markup;
          }
        })
        .catch(function () {
          /* Offline or a bad response — leave the rendered count alone rather
             than replacing it with a guess. */
        });
    }, 120);
  }

  // A cart write by anyone, not just Dawn. Both transports are patched because
  // apps use whichever they were built with.
  var nativeFetch = window.fetch;
  if (typeof nativeFetch === 'function') {
    window.fetch = function (input, init) {
      var url = typeof input === 'string' ? input : (input && input.url) || '';
      var result = nativeFetch.apply(this, arguments);
      if (CART_WRITE.test(url)) result.then(sync, function () {});
      return result;
    };
  }

  var nativeOpen = XMLHttpRequest.prototype.open;
  XMLHttpRequest.prototype.open = function (method, url) {
    if (CART_WRITE.test(url || '')) {
      this.addEventListener('load', sync);
    }
    return nativeOpen.apply(this, arguments);
  };

  // Stale HTML: a fresh load, a bfcache restore, or returning to a tab that
  // was left behind while the cart moved on elsewhere.
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', sync);
  } else {
    sync();
  }
  window.addEventListener('pageshow', function (event) {
    if (event.persisted) sync();
  });
  document.addEventListener('visibilitychange', function () {
    if (!document.hidden) sync();
  });
})();
